export const legacyRoutes = {
  list: '/admin/legacy-assigned-items',
  add: '/admin/legacy-assigned-items/add',
  edit: '/admin/legacy-assigned-items/:itemId',
  getEditLink: (itemId: string) => `/admin/legacy-assigned-items/${itemId}`,
};
